import { AppData, Lightning } from '@lightningjs/sdk'
import { Helper } from '../lib/helper'
import { AppSetup } from '../lib/app-setup'

export interface PlayerFeedbackFormItemTemplateSpec extends Lightning.Component.TemplateSpecLoose {
    Label: object
}

const REASON_BG_FOCUS = 0xffffffff
const REASON_TEXT = 0xffffffff
const REASON_TEXT_FOCUS = 0xff000000

export default class PlayerFeedbackFormItem extends Lightning.Component<PlayerFeedbackFormItemTemplateSpec> {
    itemIndex = 0
    label = ''

    static override _template(): Lightning.Component.Template<PlayerFeedbackFormItemTemplateSpec> {
        return {
            rect: true,
            color: 0x00000000,
            collision: true,
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 6 },
            Label: {
                x: 24,
                y: (h: any) => h / 2,
                mountY: 0.5,
                text: {
                    text: '',
                    fontSize: 28,
                    textColor: REASON_TEXT,
                    fontFace: Helper.getFontFamily('Regular'),
                },
            },
        } as any
    }

    set item(info: { label: string }) {
        this.label = info.label
        this.tag('Label').text.text = info.label
        this._updateStyle()
    }

    _updateStyle() {
        const focused = this.hasFocus()
        this.patch({
            color: focused ? REASON_BG_FOCUS : 0x00000000,
            Label: {
                text: {
                    textColor: focused ? REASON_TEXT_FOCUS : REASON_TEXT,
                },
            },
        })
    }

    override _focus() {
        this._updateStyle()
        const { platform } = AppData as AppSetup
        platform?.textToSpeach(this.label)
    }

    override _unfocus() {
        this._updateStyle()
    }

    override _handleEnter() {
        this.fireAncestors('$ItemSelected' as any, this.itemIndex)
        return true
    }

    _handleClick() {
        this.fireAncestors('$ItemSelected' as any, this.itemIndex)
    }

    _handleHover() {
        this.fireAncestors('$ItemHovered' as any, this.itemIndex)
    }
}
